import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Layout from './pages/Layout';
import DashboardPage from './pages/DashboardPage';
import BookingsList from './pages/BookingsList';
import BookingDetails from './pages/BookingDetails';
import Courts from './pages/Courts';
import Sports from './pages/Sports';
import Users from './pages/Users';
import './App.css';

// Check if user is authenticated
const isAuthenticated = () => {
  return localStorage.getItem('token') !== null;
};

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/bookings" element={<BookingsList />} />
            <Route path="/bookings/:id" element={<BookingDetails />} />
            <Route path="/courts" element={<Courts />} />
            <Route path="/sports" element={<Sports />} />
            <Route path="/users" element={<Users />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;